import type { IMetaData } from '~~/types/local_types';

declare global {
  interface Window {
    pa: never;
    _pac: never;
  }
}

interface IData {
  prefix: string;
  chapter1?: string | null;
  chapter2?: string | null;
  slug?: string;
  metaObject?: IMetaData;
  searchPageID?: string | null;
  page?: string;
}

/**
 *
 * This composable tracks the current and previous URLs, constructs an analytics object based on the given
 * metadata and configuration, and sends the data to the `window.pa` object.
 *
 * @param prefix - A string representing the prefix for the page (e.g., a category or section identifier).
 * @param chapter1 - An optional page identifier for the page (optional), otherwise the prefix is used.
 * @param chapter2 - An optional chapter2 for the page (optional)
 * @param slug - An optional slug for the page (used to generate the article ID).
 * @param searchPageID - Optional search page ID for the page (used to generate the article ID).
 * @param page - Optional explicit page name (defaults to the slug, otherwise the prefix).
 *
 * @example
 * sendAnalytics('news', 'breaking-news-12345', {
 *   description: 'This is a breaking news article',
 *   ogTitle: 'Breaking News!',
 *   ogType: 'article',
 *   datePublished: '2024-11-25',
 *   title: 'Breaking News - World - My Site',
 * });
 *
 * @returns {void} Sends the analytics event and logs a message if used outside a browser environment.
 */
export default function sendAnalytics({
  slug,
  prefix,
  chapter1 = null,
  chapter2 = null,
  searchPageID = null,
  page,
}: IData): void {
  // Ensure function runs in a browser environment
  if (typeof window === 'undefined') {
    console.warn('This function can only be used in a browser environment with NPO TAG loaded.');
    return;
  }

  //Send NPO Tag event
  sendNPOTagAnalytics({
    slug,
    prefix,
    chapter1,
    chapter2,
    searchPageID,
    page,
  });
}
